import { render, staticRenderFns } from "./launch-menu-admin.vue?vue&type=template&id=1e223ec0&"
import script from "./launch-menu-admin.vue?vue&type=script&lang=ts&"
export * from "./launch-menu-admin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports